import { differenceInCalendarDays, isValid, parse } from "date-fns";

/** Widest window the date-range reports accept; the picker enforces the same cap. */
export const MAX_REPORT_RANGE_DAYS = 31;

type DateRangeSearch = { dateFrom: string; dateTo: string };

function parseValidDate(value: string): Date | null {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
		return null;
	}
	const parsed = parse(value, "yyyy-MM-dd", new Date());
	return isValid(parsed) ? parsed : null;
}

/** Falls back to `fallback` on empty / malformed / reversed / oversized
 *  ranges — the same ranges the date picker prohibits. */
export function normalizeReportRange(
	{ dateFrom, dateTo }: DateRangeSearch,
	fallback: DateRangeSearch,
): DateRangeSearch {
	const start = parseValidDate(dateFrom);
	const end = parseValidDate(dateTo);
	if (
		start &&
		end &&
		differenceInCalendarDays(end, start) >= 0 &&
		differenceInCalendarDays(end, start) < MAX_REPORT_RANGE_DAYS
	) {
		return { dateFrom, dateTo };
	}
	return { dateFrom: fallback.dateFrom, dateTo: fallback.dateTo };
}
